import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { BrandingFilesState } from '@reducers/branding-files';
import { DashboardBrandingState } from '@reducers/dashboard-branding';
import { FhqBrandingState } from '@reducers/fhq-branding';

// Branding Files
export const getBrandingFiles = (state: RootState): BrandingFilesState => state.brandingFiles;
export const getBrandingFilesData = createSelector(getBrandingFiles, (branding) => branding?.data);
export const isBrandingFilesLoading = createSelector(getBrandingFiles, (branding) => branding?.loading);

// Dashboard Branding
export const getDashboardBranding = (state: RootState): DashboardBrandingState => state.dashboardBranding;
export const getDashboardBrandingData = createSelector(getDashboardBranding, (branding) => branding?.data);
export const isDashboardBrandingLoading = createSelector(getDashboardBranding, (branding) => branding?.loading);

// Fhq Branding
export const getFhqBranding = (state: RootState): FhqBrandingState => state.fhqBranding;
export const getFhqBrandingData = createSelector(getFhqBranding, (branding) => branding?.data);
export const isFhqBrandingLoading = createSelector(getFhqBranding, (branding) => branding?.loading);
